import { PaymentType } from '~/common/enums/payments.enum';

const validateFields = (
  fieldsToValidate: string[],
  validateField: (fieldName: string) => { hasError: boolean }
) =>
  fieldsToValidate.every((fieldName) => {
    const field = validateField(fieldName);
    return !field.hasError;
  });

export const validateWithdrawalForm = (
  type: PaymentType,
  validateField: (fieldName: string) => { hasError: boolean }
) =>
  type === PaymentType.CARD
    ? validateFields(['withdrawalAmount', 'cardOption'], validateField)
    : validateFields(['withdrawalAmount'], validateField);
